import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Role, BoardRole } from 'src/app/model/role';
import { map } from 'rxjs/operators';
import { RoleType } from '../model/role-type';

@Injectable({
  providedIn: 'root',
})
export class RoleService {

  constructor(private http: HttpClient) { }

  getRoles(): Observable<Role[]> {
    return this.http.get<Role[]>("assets/json-db/roles.json");
  }

  getBoardRoles() : Observable<BoardRole[]> {
    return this.http.get<BoardRole[]>("assets/json-db/roles.json").pipe(map(roles => roles.filter(role => role.roleType === RoleType.Board)));
  }
}